import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVolkswagenComponent } from './simple-icons-volkswagen.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVolkswagenComponent ],
    exports:      [ SimpleIconsVolkswagenComponent ],
    bootstrap:    []
})
export class SimpleIconsVolkswagenModule {}
